module.exports = __webpack_public_path__ + "static/media/IconWaiting.77b6b55f.svg";